import classNames from "classnames";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";
import type { BindableEventFieldset } from "../rowPrimaryIdentity";
import { useIsNewEventEnabled } from "../useIsNewEventEnabled";
import styles from "./AddNewEventButton.module.scss";

interface AddNewEventButtonProps {
    fieldset: BindableEventFieldset;
    onItemAdded: (fieldset: BindableEventFieldset) => void;
}

export const AddNewEventButton = ({ fieldset, onItemAdded }: AddNewEventButtonProps) => {
    const isDisabled = useIsNewEventEnabled({ fieldset });
    const track = useTrackSearchFormInteraction();
    const { relation, eventType } = fieldset.primaryIdentity;

    const handleClick = () => {
        track({ objectName: "add_event" });
        onItemAdded(fieldset);
    };

    return (
        <button
            type="button"
            className={classNames(styles.addEvent, "link headerLink")}
            data-testid={`add-event-${relation}-${eventType}`}
            disabled={isDisabled}
            onClick={handleClick}
        >
            {fieldset.label}
        </button>
    );
};
